import { defineComponent as b, mergeModels as r, computed as c, useId as w, useModel as y, watch as V, createElementBlock as x, openBlock as i, createElementVNode as u, withDirectives as k, createBlock as I, createCommentVNode as $, createVNode as g, unref as t, withKeys as B, vModelText as C } from "vue";
import { RevButtonIcon as M } from "@ds/components/ButtonIcon";
import P from "../../../icons/generated/IconCrossInCircle.vue2.js";
import N from "../../../icons/generated/IconSearch.vue2.js";
import { useI18n as S } from "@ds/plugin";
import d from "../../../translations/generic.translations.js";
const z = { class: "relative" }, E = { class: "absolute left-16 top-1/2 -translate-y-1/2 p-8" }, K = ["id", "placeholder"], q = /* @__PURE__ */ b({
  __name: "InputSelectSearchableSearch",
  props: /* @__PURE__ */ r({
    searchPlaceholder: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ r(["close", "update:modelValue"], ["update:modelValue"]),
  setup(a, { emit: m }) {
    const p = a, f = m, h = c(() => `${w()}_input_select_search`), n = S(), e = y(a, "modelValue"), v = c(
      () => p.searchPlaceholder || n(d.searchPlaceholder)
    );
    function _() {
      e.value = "";
    }
    return V(e, (l) => f("update:modelValue", l)), (l, o) => (i(), x("div", z, [
      u("div", E, [
        g(t(N), { class: "text-static-default-low size-24" })
      ]),
      k(u("input", {
        id: h.value,
        ref: "input",
        "onUpdate:modelValue": o[0] || (o[0] = (s) => e.value = s),
        class: "bg-action-default-min text-action-default-low focus-visible-outline-default-hi h-56 w-full rounded-none py-8 pl-64 pr-56 placeholder:text-action-default-low focus:text-action-default-low-pressed md:rounded-t-sm focus:-outline-offset-2",
        placeholder: v.value,
        type: "text",
        onKeydown: o[1] || (o[1] = B((s) => l.$emit("close"), ["esc"]))
      }, null, 40, K), [
        [C, e.value]
      ]),
      e.value ? (i(), I(t(M), {
        key: 0,
        "aria-label": t(n)(t(d).buttonClear),
        class: "text-action-default-low pointer-events-auto absolute right-8 top-1/2 size-24 -translate-y-1/2 p-8",
        "data-test": "clear-button",
        icon: t(P),
        type: "button",
        variant: "secondary",
        onClick: _
      }, null, 8, ["aria-label", "icon"])) : $("", !0)
    ]));
  }
});
export {
  q as default
};
